/**
 * @generated SignedSource<<2f62aaa15292a6856bfb4287a6985fce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type QueueActionsBuildsQuery$variables = {
  locator: string;
};
export type QueueActionsBuildsQuery$data = {
  readonly queuedBuilds: {
    readonly build: ReadonlyArray<{
      readonly rawId: number | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type QueueActionsBuildsQuery = {
  response: QueueActionsBuildsQuery$data;
  variables: QueueActionsBuildsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "locator",
    "variableName": "locator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rawId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QueueActionsBuildsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Builds",
        "kind": "LinkedField",
        "name": "queuedBuilds",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QueueActionsBuildsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Builds",
        "kind": "LinkedField",
        "name": "queuedBuilds",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Build",
            "kind": "LinkedField",
            "name": "build",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6caa0272a8b0d716c5f4daa10672bdee",
    "id": null,
    "metadata": {},
    "name": "QueueActionsBuildsQuery",
    "operationKind": "query",
    "text": "query QueueActionsBuildsQuery(\n  $locator: String!\n) {\n  queuedBuilds(locator: $locator) {\n    build {\n      rawId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "82621c256557f4f5d0e5144762fc1ce1";

export default node;
